export default __webpack_public_path__ + "static/media/auth-signup-white-card.245f388a.svg";